import { Environment } from "@/types/environment";

const development: Environment = {
    api: {
        enterprise: 'CGMP',
        baseUri: "https://api-dev.pedagioeletronicosemparar.com.br/webapi",
        baseUriAuth: "https://api-dev.pedagioeletronicosemparar.com.br",
        apiKeyAuth: "LcTRQXOrDn7p3lBHL5spY5O5lX2RbYbDCsGqqXw4",
        companyIdentification: "CGMP",
        channel: "16",
        automaticChannel: "16",
        userIdentification: "ffap",
        merchantDefinedInformation: {
            channel: "APP-RecargaPreManual"
        },
        cybersource: {
            orgId: "1snn5n9w",
            merchantId: "semparar_br",
        },
        prefix: "ff-",
        hashKey: 'lBDmE8znV1RFngzBfPEE7splx6Uj7i2O',
        loginVersion: "v1",
        app: 'PagueFF',
    },
    pci: {
        url: 'https://cyptgw-hml.fleetcor.com.br',
        key: '85de3840bc3840e837cf6313c0917a5cc030f9adab0afdd793a5cdbc08ab3357',
    },
    recaptcha: {
        siteKey: "6Le60qMrAAAAAFWEDb3P14KuOMxYqV3EziFbO6NK"
    },
}

export default development;